import { render, staticRenderFns } from "./SalvarAnuncio.vue?vue&type=template&id=4c0f8788&scoped=true"
import script from "./SalvarAnuncio.vue?vue&type=script&lang=js"
export * from "./SalvarAnuncio.vue?vue&type=script&lang=js"
import style0 from "./SalvarAnuncio.vue?vue&type=style&index=0&id=4c0f8788&prod&lang=css"
import style1 from "./SalvarAnuncio.vue?vue&type=style&index=1&id=4c0f8788&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0f8788",
  null
  
)

export default component.exports